@if(isLoading){
<div class="loading-overlay">
  <div class="loading-dialog">
    <div class="spinner-wrapper">
      <div class="custom-spinner"></div>
    </div>
    <div class="loading-text">{{'Processing...'|translate}}</div>
    <div class="loading-subtext">{{'Single Sign On Authenticating'|translate}}</div>
  </div>
</div>
} @else {
<div class="mb-5 a-walai text-center form-signin">
  @if(errMsg != '') {
  <div class="alert alert-warning rounded-4 shadow-sm mb-4" role="alert">
    <i class="bi bi-exclamation-triangle-fill me-2"></i>
    {{errMsg}}
  </div>
  }

  <div class="card border-0 shadow-lg rounded-4 overflow-hidden">
    <div class="card-body p-5">
      <h4 class="mb-4 fw-bold">{{'Single Sign On'|translate}}</h4>
      <p class="text-muted mb-4">เข้าใช้งานระบบด้วยบัญชีสถาบันของคุณ</p>
      <button class="btn btn-primary btn-lg w-100 rounded-pill py-3 px-5 shadow-sm" (click)="clickLogin()">
        <i class="bi bi-box-arrow-in-right me-2"></i>
        {{'Sign In with SSO'|translate}}
      </button>
    </div>
  </div>
</div>
}